
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class EaseBuzzSettingsGrid extends Serenity.EntityGrid<EaseBuzzSettingsRow, any> {
        protected getColumnsKey() { return EaseBuzzSettingsColumns.columnsKey; }
        protected getDialogType() { return EaseBuzzSettingsDialog; }
        protected getIdProperty() { return EaseBuzzSettingsRow.idProperty; }
        protected getInsertPermission() { return EaseBuzzSettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return EaseBuzzSettingsRow.localTextPrefix; }
        protected getService() { return EaseBuzzSettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}